<div
  class="mx-auto flex w-full max-w-lg flex-col items-center gap-6 px-4 py-8 text-center"
  [attr.role]="isFailure() ? 'alert' : 'status'"
>
  <ng-content select="[empty-state-illustration]" />

  @if (showIcon()) {
    <liv-icon
      [ngClass]="{
        'text-feedback-error-medium': isFailure(),
        'text-text-medium': !isFailure()
      }"
      [name]="resolvedIcon()"
      size="48"
    />
  }

  <div class="flex w-full min-w-0 flex-col items-center gap-2">
    @if (title()) {
      <h3 class="text-text-heading text-base font-medium">
        {{ title() }}
      </h3>
    }

    @if (description()) {
      <p
        class="text-text-medium w-full max-w-xs min-w-0 text-sm leading-relaxed wrap-anywhere"
      >
        {{ description() }}
      </p>
    }
  </div>

  @if (isFailure() && showRetry()) {
    <button
      livButton
      class="mt-1"
      type="button"
      variant="link"
      intent="primary"
      size="sm"
      (click)="onRetry()"
    >
      {{ retryLabel() ?? ('ui.try_again' | translate) }}
    </button>
  }

  <ng-content select="[empty-state-action]" />
</div>
